// Punto de entrada de la SPA. Reemplaza al arranque implícito que hacía Next:
// monta React, enciende el router y carga los estilos globales.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./globals.css";

const contenedor = document.getElementById("root");
if (!contenedor) throw new Error("Falta <div id=\"root\"> en index.html");

createRoot(contenedor).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
